@if (menuVisible()) {
  <div class="left">
    <button pButton
      id="menu-button"
      class="p-button-nonbutton light"
      (click)="menuButtonClick.emit(); $event.preventDefault();"
      aria-label="Menu"
      icon="pi pi-angle-left">
    </button>
  </div>
}

<span class="logo">
  @if (isPropak) {
    <img src="/logo-propak-white.svg" alt="" />
    <span class="logo-text">
      PROPAK Vision{{ isTestEnvironment ? ' Test' : '' }}
    </span>
  }
  @else {
    <img src="/logo-white.svg" alt="PLA" />
    <span class="logo-text">
      Vision{{ isTestEnvironment ? ' Test' : '' }}
    </span>
  }
</span>

@if (!!username) {
  <div class="right">
    @if (isTestEnvironment) {
      <span>
        <button pButton severity="secondary" (click)="openDialog()"
          [label]="displayName" [title]="username">
        </button>
      </span>
      }
    @else {
      <span [title]="username">
        {{ displayName }}
      </span>
    }

    <button pButton (click)="logout()" label="Sign Out" icon="pi pi-sign-out" iconPos="right"
      class="p-button-nonbutton light"></button>
  </div>
}

<p-dialog header="Impersonate User" [modal]="true" [(visible)]="showImpersonateDialog">
  <p>Impersonation is temporarily unavailable. Contact Sam if you have questions.</p>
  <div >
    <label class="required" for="description">User Account</label>
    <input pInputText type="text" id="description" [(ngModel)]="impersonationUsername" disabled />
  </div>
  <button pButton type="button" severity="info" label="Stop Impersonation" (click)="cancelImpersonation()"></button>
  <button pButton type="button" severity="success" label="Start Impersonation" (click)="setImpersonation()"></button>

</p-dialog>
